// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Qu-z","breadcrumbForward":"Ru-z","breadcrumbBack":"Su-z","selected":"Tu-z"};